// Curated unsplash imagery — chemistry, laboratory, abstract science
export const IMAGES = {
  heroBg: "https://images.unsplash.com/photo-1663086213378-baf071a00d50?auto=format&fit=crop&w=1800&q=80",
  heroPortrait: "https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?auto=format&fit=crop&w=1200&q=80",
  about: "https://images.unsplash.com/photo-1582719471384-894fbb16e074?auto=format&fit=crop&w=1400&q=80",
  aboutOffice: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1400&q=80",
  servicesAccent: "https://images.unsplash.com/photo-1601961545517-59307b1fbac3?auto=format&fit=crop&w=1400&q=80",
  lab: "https://images.unsplash.com/photo-1606206873764-fd15e242df52?auto=format&fit=crop&w=1400&q=80",
  molecule: "https://images.unsplash.com/photo-1554475901-4538ddfbccc2?auto=format&fit=crop&w=1400&q=80",
  document: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1400&q=80",
  consult: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=1400&q=80",
};

/**
 * Each service has a detail page at /hizmetler/:slug
 * Structure:
 *  - slug, icon, image, title, tagline, short, description
 *  - highlights: short bullet list of sub-services (sidebar)
 *  - sections: [{ heading, paragraphs?: string[], bullets?: string[] }]
 *  - faqs: [{ q, a }]
 *
 * Content is maintained in two parallel arrays (TR / EN) that share the same
 * `slug` order so a lookup by index or slug works identically in both
 * languages. Use `getServices(lang)` rather than importing SERVICES_TR /
 * SERVICES_EN directly.
 */
export const SERVICES_TR = [
  {
    slug: "kkdik-madde-kayit",
    icon: "Hexagon",
    image: "https://images.unsplash.com/photo-1581093588401-fbb62a02f120?auto=format&fit=crop&w=1600&q=80",
    title: "KKDİK Madde Kayıt Süreçleri",
    tagline: "KKDİK Danışmanlığı ve Turkey REACH Uyum Hizmeti",
    short: "KKDİK kapsamındaki kayıt süreçlerinin planlanması ve teknik desteği.",
    description:
      "Yıllık 1 ton üzeri madde imalatçı/ithalatçılar için kayıt yol haritası, lider kayıt eden koordinasyonu ve teknik dosya teslimi.",
    highlights: [
      "KKDİK Kapsam Analizi",
      "KKS İşlemleri",
      "Ön Kayıt / Geçici / Tam Kayıt",
      "Lider Firma & Ortak Kayıt",
      "Turkey REACH Uyum",
    ],
    sections: [
      {
        heading: "KKDİK Nedir?",
        paragraphs: [
          "KKDİK, “Kimyasalların Kaydı, Değerlendirilmesi, İzni ve Kısıtlanması Hakkında Yönetmelik” ifadesinin kısaltmasıdır. Avrupa Birliği REACH yaklaşımına paralel şekilde Türkiye’de kimyasal maddelerin insan sağlığı ve çevre üzerindeki etkilerini kontrol altına almak amacıyla hazırlanmıştır.",
          "Yönetmelik; kimyasalların kaydı, değerlendirilmesi, izne tabi tutulması ve kısıtlanması süreçlerine ilişkin idari ve teknik esasları içerir. KKDİK süreci yalnızca bir “başvuru” işlemi değil; madde bazlı, tonaj bazlı ve rol bazlı bir uyum çalışmasıdır.",
        ],
      },
      {
        heading: "KKDİK ve REACH Arasındaki İlişki",
        paragraphs: [
          "AB’de yürürlükte olan REACH düzenlemesi; kimyasal maddelerin kayıt, değerlendirme, izin ve kısıtlama süreçlerini düzenler. Türkiye’deki KKDİK Yönetmeliği de bu yaklaşıma paralel olarak kimyasalların güvenli kullanımını ve kayıt altına alınmasını hedefler.",
          "Uluslararası tedarik zincirinde çalışan, AB ile ticaret yapan, ithalat gerçekleştiren veya Türkiye pazarına kimyasal ürün sunan firmalar için KKDİK uyumu stratejik bir gereklilik haline gelmiştir.",
        ],
      },
      {
        heading: "KKDİK Yönetmeliği Kimleri Kapsar?",
        paragraphs: [
          "KKDİK kapsamı; firmanın tedarik zincirindeki rolüne, imal veya ithal edilen maddenin türüne, yıllık tonajına, kullanım alanına ve muafiyet durumuna göre değerlendirilmelidir.",
        ],
        bullets: [
          "Türkiye’de kimyasal madde imal eden firmalar",
          "Kimyasal madde veya karışım ithal eden firmalar",
          "Karışım içinde madde piyasaya arz eden işletmeler",
          "Eşya içinde salınımı amaçlanan madde bulunduran firmalar",
          "Yurt dışı üreticiler adına tek temsilcilik süreci yürüten kuruluşlar",
          "Alt kullanıcı, distribütör veya tedarik zinciri aktörü olarak kimyasal ürün kullanan işletmeler",
        ],
      },
      {
        heading: "KKDİK Kapsamındaki Roller",
        bullets: [
          "İmalatçı: Türkiye’de kimyasal madde üreten firma.",
          "İthalatçı: Kimyasal madde, karışım veya eşya içinde madde ithal eden firma.",
          "Alt kullanıcı: Kimyasal madde veya karışımı endüstriyel/profesyonel faaliyetinde kullanan taraf.",
          "Distribütör: Kimyasal ürünleri depolayan ve piyasaya arz eden tedarik zinciri aktörü.",
          "Tek temsilci: Yurt dışı üretici adına Türkiye’de KKDİK yükümlülüklerini üstlenen taraf.",
          "Üçüncü taraf temsilci: Belirli süreçlerde firma adına temsil ve iletişim görevlerini yürütebilen temsilci.",
        ],
      },
      {
        heading: "KKDİK Kayıt Süreci Nasıl İlerler?",
        bullets: [
          "Firma rolü ve kapsam analizi yapılır.",
          "Madde adı, CAS/EC, tonaj ve kullanım bilgileri ile envanter çıkarılır.",
          "Muafiyet ve kapsam dışı durumlar kontrol edilir.",
          "KKS ve ön kayıt/MBDF durumu incelenir.",
          "Ortak kayıt, lider firma ve veri/maliyet paylaşımı stratejisi takip edilir.",
          "Geçici / tam kayıt için teknik dosya hazırlanır.",
          "Kayıt sonrası güncelleme ve tedarik zinciri iletişimi sürdürülür.",
        ],
      },
      {
        heading: "Güncel KKDİK Son Kayıt Tarihleri",
        paragraphs: [
          "Eski içeriklerde 31.12.2023 tarihi görülebilir; ancak son düzenlemelerle kayıt tarihleri tonaj ve zararlılık sınıfına göre kademeli olarak revize edilmiştir.",
        ],
        bullets: [
          "30.09.2026 — Geçici kayıt (ön kayıt sonrası) yükümlülüğü bulunan maddeler için son geçici kayıt tarihi.",
          "31.12.2026 — Yüksek tonajlı ve yüksek zararlılık sınıflarındaki maddeler için öncelikli kayıt dönemi.",
          "31.12.2028 — 100 ton/yıl ve üzeri maddeler için kayıt dönemi.",
          "31.12.2030 — 1 ton/yıl ve üzeri tüm maddeler için son kayıt dönemi.",
        ],
      },
    ],
    faqs: [
      { q: "KKDİK nedir?", a: "Türkiye’de kimyasal maddelerin kayıt, değerlendirme, izin ve kısıtlama süreçlerini düzenleyen kimyasal mevzuattır." },
      { q: "KKDİK kaydı kimler için gereklidir?", a: "Türkiye’de yıllık tonaj ve kapsam koşullarına göre kimyasal madde imal eden veya ithal eden firmalar için kayıt yükümlülüğü oluşabilir. Her firma için madde ve rol bazlı değerlendirme yapılmalıdır." },
      { q: "KKDİK ile REACH aynı şey mi?", a: "KKDİK, AB REACH düzenlemesine paralel hazırlanmış Türkiye mevzuatıdır. Süreç, sistem ve ulusal gereklilikler açısından ayrı değerlendirilmelidir." },
      { q: "KKDİK sürecinde MSDS/GBF gerekli mi?", a: "Evet. Güvenlik Bilgi Formları, zararlılık sınıflandırması ve tedarik zinciri iletişimi açısından KKDİK süreciyle doğrudan ilişkilidir." },
      { q: "KKDİK kayıt tarihleri güncellendi mi?", a: "Evet. Son kayıt tarihleri 31.12.2026, 31.12.2028 ve 31.12.2030 olacak şekilde kademeli hale gelmiştir. Madde bazında değerlendirme gerekir." },
    ],
  },

  {
    slug: "on-mbdf",
    icon: "FileText",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1600&q=80",
    title: "Ön-MBDF Süreçleri",
    tagline: "Veri Paylaşımı ve Kayıt Öncesi Hazırlık",
    short: "Veri paylaşımı ve kayıt öncesi hazırlık desteği.",
    description:
      "SIEF içi iletişim, lider kayıt eden seçimi, LoA ve maliyet paylaşım anlaşmalarının yönetimi.",
    highlights: [
      "Ön-MBDF Kayıt Kontrolü",
      "SIEF İletişimi",
      "Lider Kayıt Eden Seçimi",
      "LoA & Maliyet Paylaşımı",
    ],
    sections: [
      {
        heading: "Ön-MBDF Nedir?",
        paragraphs: [
          "Ön-MBDF (Madde Bilgi Değişim Forumu), aynı maddeyi kaydetmekle yükümlü tarafların veri paylaşımı yaptığı platformdur. Verimli bir Ön-MBDF süreci kayıt maliyetini doğrudan etkiler.",
          "Sürecin temel amacı; aynı madde için tekrar eden test çalışmalarını önlemek, lider kayıt eden etrafında ortak kayıt yapısı kurmak ve maliyet–veri paylaşımını adil biçimde planlamaktır.",
        ],
      },
      {
        heading: "Sürecin Kritik Aşamaları",
        bullets: [
          "Madde kimliği ve CAS/EC eşleştirmesi",
          "Lider kayıt eden (Lead Registrant) seçimi",
          "SIEF (Substance Information Exchange Forum) içi iletişim",
          "Veri ihtiyaç analizi ve test stratejisi",
          "LoA (Letter of Access) düzenlenmesi",
          "Per capita / advanced maliyet paylaşım modelinin belirlenmesi",
        ],
      },
      {
        heading: "Hizmet Kapsamımız",
        bullets: [
          "Ön-MBDF üyeliği oluşturma ve takip",
          "SIEF üyeleri ile resmî yazışmaların yürütülmesi",
          "Veri sahipliği ve LoA hakları değerlendirmesi",
          "Maliyet paylaşım anlaşması (CSA) inceleme ve müzakere desteği",
        ],
      },
    ],
    faqs: [
      { q: "Ön-MBDF zorunlu mu?", a: "Aynı maddeyi kaydetmekle yükümlü tarafların ön-MBDF kapsamında iletişim kurması mevzuat gereği zorunludur." },
      { q: "LoA neyi kapsar?", a: "LoA, lider kayıt eden tarafından paylaşılan veri setini kullanma hakkını tanımlayan resmi belgedir." },
      { q: "Maliyet paylaşımı nasıl yapılır?", a: "Genellikle per capita (eşit) veya tonaj/veri ağırlıklı modellerle yapılır; CSA ile yazılı hale getirilir." },
    ],
  },

  {
    slug: "sea-siniflandirma",
    icon: "Tags",
    image: "https://images.unsplash.com/photo-1532187643603-ba119ca4109e?auto=format&fit=crop&w=1600&q=80",
    title: "SEA Sınıflandırma ve Etiketleme",
    tagline: "SEA (CLP) Uyumlu Sınıflandırma ve Etiket Tasarımı",
    short: "Kimyasalların SEA Yönetmeliğine uygun sınıflandırılması ve etiketleme desteği.",
    description:
      "CLP uyumlu sınıflandırma, H/P ifadeleri, piktogram seçimi ve ambalaj etiket tasarım denetimi.",
    highlights: [
      "Tehlike Sınıflandırması",
      "H/P İfadeleri",
      "Piktogram Seçimi",
      "Etiket Tasarım Denetimi",
    ],
    sections: [
      {
        heading: "SEA (CLP) Yönetmeliği Nedir?",
        paragraphs: [
          "Sınıflandırma, Etiketleme ve Ambalajlama (SEA) Yönetmeliği; AB CLP düzenlemesine paralel şekilde kimyasalların tehlike sınıflarını, etiket bilgilerini ve ambalaj kurallarını belirler.",
        ],
      },
      {
        heading: "Sınıflandırma Kriterleri",
        bullets: [
          "Fiziksel tehlikeler (yanıcı, patlayıcı, oksitleyici, vb.)",
          "Sağlık tehlikeleri (akut toksisite, kanserojen, üreme toksisitesi)",
          "Çevresel tehlikeler (suda yaşayan canlılara toksik etki)",
        ],
      },
      {
        heading: "Etikette Zorunlu Unsurlar",
        bullets: [
          "Ürün tanımlayıcı",
          "Tehlike piktogramları",
          "Sinyal kelime (Tehlike / Dikkat)",
          "H ve P ifadeleri",
          "Tedarikçi bilgileri",
          "Ambalaj miktarı bilgisi",
        ],
      },
    ],
    faqs: [
      { q: "Karışımlar nasıl sınıflandırılır?", a: "Karışım bileşenlerinin tehlike verilerine göre hesaplama yöntemiyle veya doğrudan test verisi ile sınıflandırma yapılır." },
      { q: "Etiket dili Türkçe mi olmalı?", a: "Türkiye’de piyasaya arz edilen ürünlerde etiket Türkçe olmalı, ihracatta hedef pazarın dili kullanılmalıdır." },
    ],
  },

  {
    slug: "sds-gbf",
    icon: "FileCheck",
    image: "https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?auto=format&fit=crop&w=1600&q=80",
    title: "SDS / GBF Hazırlama",
    tagline: "Türkçe & İngilizce Güvenlik Bilgi Formu",
    short: "Türkçe ve İngilizce Güvenlik Bilgi Formlarının hazırlanması ve revizyonu.",
    description:
      "16 bölümlük GBF hazırlama, çeviri, periyodik revizyon ve müşteri yayın desteği.",
    highlights: [
      "16 Bölümlük GBF",
      "TR & EN Çeviri",
      "Periyodik Revizyon",
      "Müşteri Yayın Desteği",
    ],
    sections: [
      {
        heading: "Güvenlik Bilgi Formu (GBF / SDS) Nedir?",
        paragraphs: [
          "Güvenlik Bilgi Formu, tedarik zincirinde tehlike iletişimini sağlayan resmi bir teknik dokümandır. 16 bölümden oluşur ve mevzuata uygunluğu zorunludur.",
        ],
      },
      {
        heading: "Sık Yapılan Hatalar",
        bullets: [
          "Sınıflandırmanın güncel SEA mevzuatına göre revize edilmemesi",
          "Bölüm 3’te bileşen konsantrasyonlarının eksik verilmesi",
          "Bölüm 8’de DNEL/PNEC değerlerinin atlanması",
          "Bölüm 14’te taşımacılık bilgilerinin güncellenmemesi",
        ],
      },
      {
        heading: "Hizmet Kapsamımız",
        bullets: [
          "Yeni GBF hazırlama (TR / EN)",
          "Mevcut formların mevzuata göre revizyonu",
          "Periyodik güncelleme takibi",
          "Tedarik zincirine yayın stratejisi",
        ],
      },
    ],
    faqs: [
      { q: "GBF ne sıklıkla güncellenmeli?", a: "12 ayda bir veya yeni veri çıktığında, ayrıca formülasyon/sınıflandırma değişikliğinde revize edilmelidir." },
      { q: "İngilizce GBF gerekli midir?", a: "Türkiye dışına ihracat yapan firmalar için ilgili dilde GBF düzenlenmesi gereklidir." },
    ],
  },

  {
    slug: "ufi-pcn",
    icon: "BellRing",
    image: "https://images.unsplash.com/photo-1554475901-4538ddfbccc2?auto=format&fit=crop&w=1600&q=80",
    title: "UFI ve PCN Bildirimleri",
    tagline: "Karışımlar için Bildirim Yönetimi",
    short: "Karışımlar için gerekli bildirim süreçlerinin yönetimi.",
    description:
      "UFI kodu oluşturma, PCN portali bildirimleri ve formülasyon güncellemelerinin takibi.",
    highlights: [
      "UFI Kodu Oluşturma",
      "PCN Portal Bildirimi",
      "Formülasyon Takibi",
      "Tüketici/Profesyonel Kullanım",
    ],
    sections: [
      {
        heading: "UFI ve PCN Nedir?",
        paragraphs: [
          "UFI (Unique Formula Identifier), karışım formülasyonunu benzersiz şekilde tanımlayan 16 karakterli koddur. PCN bildirimi, tehlikeli karışımların zehir danışma merkezlerine sunulması zorunlu bildirimidir.",
        ],
      },
      {
        heading: "Hangi Karışımlar Bildirilmeli?",
        bullets: [
          "Sağlık veya fiziksel tehlike sınıflandırması taşıyan tüm karışımlar",
          "Tüketici kullanımı için piyasaya arz edilen ürünler",
          "Profesyonel kullanım için piyasaya arz edilen ürünler",
        ],
      },
      {
        heading: "Hizmet Kapsamımız",
        bullets: [
          "UFI kodu oluşturma ve kayıt",
          "PCN dosyası hazırlığı ve portal bildirimi",
          "Formülasyon değişikliklerinin takibi",
          "Bildirim güncellemelerinin yönetimi",
        ],
      },
    ],
    faqs: [
      { q: "UFI kodu nereden alınır?", a: "Resmi UFI Generator aracı ile firmanın VKN/MTN bilgilerinden üretilir." },
      { q: "Formülasyon değişikliğinde ne yapılır?", a: "Yeni bir UFI üretilerek PCN bildirimi güncellenir; etiket yeniden basılır." },
    ],
  },

  {
    slug: "kimyasal-envanter",
    icon: "Database",
    image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1600&q=80",
    title: "Kimyasal Envanter Kontrolü",
    tagline: "Mevzuat Uyumlu Envanter Analizi",
    short: "Mevzuat yükümlülüklerinin değerlendirilmesi ve envanter analizi.",
    description:
      "CAS/EC bazlı envanter taraması, tonaj analizi ve çoklu rejim yükümlülük raporu.",
    highlights: [
      "CAS / EC Eşleştirme",
      "Tonaj Analizi",
      "Yükümlülük Haritası",
      "Risk Önceliklendirme",
    ],
    sections: [
      {
        heading: "Neden Envanter Kontrolü?",
        paragraphs: [
          "Kimyasal envanter, yalnızca depo yönetimi değil; aynı zamanda bir mevzuat uyumluluk aracıdır. Doğru tutulan bir envanter; KKDİK, SEA, Biyosidal ve REACH gibi çoklu rejimlerde yükümlülük analizini kolaylaştırır.",
        ],
      },
      {
        heading: "Çalışma Kapsamımız",
        bullets: [
          "CAS / EC numarası bazında madde tespiti",
          "Yıllık tonaj takibi (üretim + ithalat)",
          "Kullanım amacı (DU, ara madde, formülasyon) değerlendirmesi",
          "İlgili mevzuat yükümlülük haritası",
          "Risk önceliklendirme raporu",
        ],
      },
    ],
    faqs: [
      { q: "Envanter çalışması ne kadar sürer?", a: "Madde sayısı ve veri kalitesine göre tipik olarak 2–6 hafta arasında tamamlanır." },
      { q: "Hangi sıklıkla yenilenmeli?", a: "Yılda en az bir kez kapsamlı tarama önerilir; formülasyon değişiminde anlık güncelleme yapılır." },
    ],
  },

  {
    slug: "teknik-dosya",
    icon: "FolderCog",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1600&q=80",
    title: "Teknik Dosya Hazırlama",
    tagline: "IUCLID ve Kimyasal Güvenlik Raporu",
    short: "Kimyasal mevzuat kapsamında gerekli teknik dokümanların hazırlanmasına destek.",
    description:
      "IUCLID dosyaları, kimyasal güvenlik raporu (CSR) ve maruz kalma senaryolarının hazırlanması.",
    highlights: [
      "IUCLID Dosyası",
      "Kimyasal Güvenlik Raporu (CSR)",
      "Maruz Kalma Senaryoları",
      "Teknik Veri Toplama",
    ],
    sections: [
      {
        heading: "Teknik Dosya Nedir?",
        paragraphs: [
          "KKDİK ve REACH kapsamında kaydı yapılan maddeler için sunulması gereken teknik veri setidir. Madde kimliği, fizikokimyasal özellikler, toksikolojik ve ekotoksikolojik veriler ile maruz kalma senaryolarını içerir.",
        ],
      },
      {
        heading: "Hizmet Kapsamımız",
        bullets: [
          "IUCLID dosyası oluşturma ve düzenleme",
          "Madde kimliği (Substance Identity) raporu",
          "(Q)SAR / read-across stratejisi",
          "Kimyasal Güvenlik Raporu (CSR) hazırlanması",
          "Maruz kalma senaryosu modellemeleri",
        ],
      },
    ],
    faqs: [
      { q: "Tonaj bandı dosya içeriğini etkiler mi?", a: "Evet. Tonaj arttıkça daha geniş veri seti ve test çalışması gerekir." },
      { q: "Test verisi yoksa ne yapılır?", a: "Read-across, QSAR ve weight-of-evidence yaklaşımları ile veri boşlukları doldurulabilir." },
    ],
  },
];

export const SERVICES_EN = [
  {
    slug: "kkdik-madde-kayit",
    icon: "Hexagon",
    image: "https://images.unsplash.com/photo-1581093588401-fbb62a02f120?auto=format&fit=crop&w=1600&q=80",
    title: "KKDİK Substance Registration Processes",
    tagline: "KKDİK Consultancy and Turkey REACH Compliance Service",
    short: "Planning and technical support for registration processes under KKDİK.",
    description:
      "A registration roadmap, lead-registrant coordination, and technical dossier delivery for manufacturers/importers of substances above 1 tonne/year.",
    highlights: [
      "KKDİK Scope Analysis",
      "KKS (Registration System) Procedures",
      "Pre-registration / Provisional / Full Registration",
      "Lead Company & Joint Registration",
      "Turkey REACH Compliance",
    ],
    sections: [
      {
        heading: "What Is KKDİK?",
        paragraphs: [
          "KKDİK is the Turkish abbreviation for the “Regulation on the Registration, Evaluation, Authorisation and Restriction of Chemicals.” Modeled on the EU REACH approach, it was prepared to control the effects of chemical substances on human health and the environment in Turkey.",
          "The regulation sets out the administrative and technical principles for the registration, evaluation, authorisation, and restriction of chemicals. The KKDİK process is not merely an “application” — it is a compliance effort organized by substance, tonnage band, and role.",
        ],
      },
      {
        heading: "The Relationship Between KKDİK and REACH",
        paragraphs: [
          "The EU's REACH regulation governs the registration, evaluation, authorisation, and restriction of chemical substances. Turkey's KKDİK Regulation follows the same approach, aiming to ensure the safe use and registration of chemicals.",
          "For companies operating in international supply chains, trading with the EU, importing goods, or placing chemical products on the Turkish market, KKDİK compliance has become a strategic requirement.",
        ],
      },
      {
        heading: "Who Does the KKDİK Regulation Cover?",
        paragraphs: [
          "The scope of KKDİK should be assessed based on the company's role in the supply chain, the type of substance manufactured or imported, its annual tonnage, its intended use, and any exemption status.",
        ],
        bullets: [
          "Companies manufacturing chemical substances in Turkey",
          "Companies importing chemical substances or mixtures",
          "Businesses placing substances on the market within mixtures",
          "Companies holding substances intended for release from articles",
          "Organizations acting as Only Representative for foreign manufacturers",
          "Downstream users, distributors, or other supply-chain actors using chemical products",
        ],
      },
      {
        heading: "Roles Under KKDİK",
        bullets: [
          "Manufacturer: a company that produces chemical substances in Turkey.",
          "Importer: a company that imports a chemical substance, mixture, or article containing a substance.",
          "Downstream user: a party that uses a chemical substance or mixture in its industrial or professional activity.",
          "Distributor: a supply-chain actor that stores and places chemical products on the market.",
          "Only Representative: a party that assumes KKDİK obligations in Turkey on behalf of a foreign manufacturer.",
          "Third-party representative: a representative who may carry out representation and communication duties on a company's behalf in certain processes.",
        ],
      },
      {
        heading: "How Does the KKDİK Registration Process Work?",
        bullets: [
          "The company's role and scope are analyzed.",
          "An inventory is compiled with substance name, CAS/EC number, tonnage, and use information.",
          "Exemptions and out-of-scope situations are checked.",
          "KKS and pre-registration/MBDF (SIEF) status are reviewed.",
          "A joint-registration, lead-company, and data/cost-sharing strategy is followed.",
          "A technical dossier is prepared for provisional/full registration.",
          "Post-registration updates and supply-chain communication are maintained.",
        ],
      },
      {
        heading: "Current KKDİK Final Registration Deadlines",
        paragraphs: [
          "Older materials may still reference 31 December 2023; however, recent amendments have revised the registration deadlines on a phased basis according to tonnage and hazard class.",
        ],
        bullets: [
          "30 September 2026 — final deadline for provisional registration (following pre-registration) for substances subject to that obligation.",
          "31 December 2026 — priority registration period for high-tonnage substances and substances in higher hazard classes.",
          "31 December 2028 — registration period for substances at 100 tonnes/year and above.",
          "31 December 2030 — final registration period for all substances at 1 tonne/year and above.",
        ],
      },
    ],
    faqs: [
      { q: "What is KKDİK?", a: "It is Turkey's chemicals legislation governing the registration, evaluation, authorisation, and restriction of chemical substances." },
      { q: "Who is required to register under KKDİK?", a: "Depending on annual tonnage and scope conditions, companies manufacturing or importing chemical substances in Turkey may be subject to a registration obligation. Each company must be assessed on a substance- and role-specific basis." },
      { q: "Is KKDİK the same as REACH?", a: "KKDİK is Turkish legislation prepared in parallel with the EU REACH regulation. The process, system, and national requirements should be evaluated separately." },
      { q: "Is an SDS required during the KKDİK process?", a: "Yes. Safety data sheets are directly related to the KKDİK process in terms of hazard classification and supply-chain communication." },
      { q: "Have the KKDİK registration deadlines been updated?", a: "Yes. The final registration deadlines are now phased as 31 December 2026, 31 December 2028, and 31 December 2030. A substance-by-substance assessment is required." },
    ],
  },

  {
    slug: "on-mbdf",
    icon: "FileText",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1600&q=80",
    title: "Pre-SIEF (Pre-MBDF) Processes",
    tagline: "Data Sharing and Pre-Registration Preparation",
    short: "Support for data sharing and pre-registration preparation.",
    description:
      "Management of SIEF communication, lead-registrant selection, Letters of Access (LoA), and cost-sharing agreements.",
    highlights: [
      "Pre-MBDF Registration Check",
      "SIEF Communication",
      "Lead Registrant Selection",
      "LoA & Cost Sharing",
    ],
    sections: [
      {
        heading: "What Is Pre-MBDF?",
        paragraphs: [
          "Pre-MBDF (the pre-registration Substance Information Exchange Forum) is the platform where parties obligated to register the same substance share data. An efficient Pre-MBDF process directly affects registration cost.",
          "The main purpose of the process is to prevent duplicate testing for the same substance, establish a joint-registration structure around a lead registrant, and plan cost/data sharing fairly.",
        ],
      },
      {
        heading: "Key Stages of the Process",
        bullets: [
          "Substance identity and CAS/EC matching",
          "Selection of the Lead Registrant",
          "Communication within the SIEF (Substance Information Exchange Forum)",
          "Data-needs analysis and testing strategy",
          "Issuance of the Letter of Access (LoA)",
          "Determining the per-capita / advanced cost-sharing model",
        ],
      },
      {
        heading: "Our Scope of Service",
        bullets: [
          "Establishing and tracking Pre-MBDF membership",
          "Conducting official correspondence with SIEF members",
          "Assessing data ownership and LoA rights",
          "Reviewing and negotiating the Cost Sharing Agreement (CSA)",
        ],
      },
    ],
    faqs: [
      { q: "Is Pre-MBDF mandatory?", a: "Communication among parties obligated to register the same substance within the Pre-MBDF is required by regulation." },
      { q: "What does an LoA cover?", a: "The LoA is the official document that defines the right to use the data set shared by the lead registrant." },
      { q: "How is the cost shared?", a: "It is generally done through per-capita (equal) or tonnage/data-weighted models, formalized in a CSA." },
    ],
  },

  {
    slug: "sea-siniflandirma",
    icon: "Tags",
    image: "https://images.unsplash.com/photo-1532187643603-ba119ca4109e?auto=format&fit=crop&w=1600&q=80",
    title: "SEA Classification and Labelling",
    tagline: "SEA (CLP)-Compliant Classification and Label Design",
    short: "Support for classifying and labelling chemicals in line with the SEA Regulation.",
    description:
      "CLP-compliant classification, H/P statements, pictogram selection, and packaging label design review.",
    highlights: [
      "Hazard Classification",
      "H/P Statements",
      "Pictogram Selection",
      "Label Design Review",
    ],
    sections: [
      {
        heading: "What Is the SEA (CLP) Regulation?",
        paragraphs: [
          "The Classification, Labelling and Packaging (SEA) Regulation, modeled on the EU CLP regulation, defines the hazard classes, label information, and packaging rules for chemicals.",
        ],
      },
      {
        heading: "Classification Criteria",
        bullets: [
          "Physical hazards (flammable, explosive, oxidizing, etc.)",
          "Health hazards (acute toxicity, carcinogenicity, reproductive toxicity)",
          "Environmental hazards (toxicity to aquatic organisms)",
        ],
      },
      {
        heading: "Mandatory Label Elements",
        bullets: [
          "Product identifier",
          "Hazard pictograms",
          "Signal word (Danger / Warning)",
          "H and P statements",
          "Supplier information",
          "Nominal quantity information",
        ],
      },
    ],
    faqs: [
      { q: "How are mixtures classified?", a: "Mixtures are classified using calculation methods based on the hazard data of their components, or directly with test data." },
      { q: "Must the label be in Turkish?", a: "Products placed on the market in Turkey must be labelled in Turkish; for exports, the language of the target market should be used." },
    ],
  },

  {
    slug: "sds-gbf",
    icon: "FileCheck",
    image: "https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?auto=format&fit=crop&w=1600&q=80",
    title: "SDS Preparation",
    tagline: "Turkish & English Safety Data Sheets",
    short: "Preparation and revision of Turkish and English Safety Data Sheets.",
    description:
      "Preparation of 16-section SDSs, translation, periodic revision, and support for distributing them to customers.",
    highlights: [
      "16-Section SDS",
      "TR & EN Translation",
      "Periodic Revision",
      "Customer Distribution Support",
    ],
    sections: [
      {
        heading: "What Is a Safety Data Sheet (SDS)?",
        paragraphs: [
          "The Safety Data Sheet is an official technical document that ensures hazard communication along the supply chain. It consists of 16 sections, and compliance with the regulation is mandatory.",
        ],
      },
      {
        heading: "Common Mistakes",
        bullets: [
          "Classification not revised in line with the current SEA legislation",
          "Component concentrations missing in Section 3",
          "DNEL/PNEC values omitted in Section 8",
          "Transport information in Section 14 not updated",
        ],
      },
      {
        heading: "Our Scope of Service",
        bullets: [
          "Preparing new SDSs (TR / EN)",
          "Revising existing forms in line with the regulation",
          "Tracking periodic updates",
          "Supply-chain distribution strategy",
        ],
      },
    ],
    faqs: [
      { q: "How often should an SDS be updated?", a: "It should be revised every 12 months, whenever new data becomes available, and whenever the formulation or classification changes." },
      { q: "Is an English SDS required?", a: "For companies exporting outside Turkey, an SDS must be prepared in the relevant language." },
    ],
  },

  {
    slug: "ufi-pcn",
    icon: "BellRing",
    image: "https://images.unsplash.com/photo-1554475901-4538ddfbccc2?auto=format&fit=crop&w=1600&q=80",
    title: "UFI and PCN Notifications",
    tagline: "Notification Management for Mixtures",
    short: "Management of the notification processes required for mixtures.",
    description:
      "UFI code generation, PCN portal notifications, and tracking of formulation updates.",
    highlights: [
      "UFI Code Generation",
      "PCN Portal Notification",
      "Formulation Tracking",
      "Consumer/Professional Use",
    ],
    sections: [
      {
        heading: "What Are UFI and PCN?",
        paragraphs: [
          "The UFI (Unique Formula Identifier) is a 16-character code that uniquely identifies a mixture's formulation. PCN notification is the mandatory submission of hazardous-mixture information to poison control centres.",
        ],
      },
      {
        heading: "Which Mixtures Must Be Notified?",
        bullets: [
          "All mixtures classified for health or physical hazards",
          "Products placed on the market for consumer use",
          "Products placed on the market for professional use",
        ],
      },
      {
        heading: "Our Scope of Service",
        bullets: [
          "Generating and registering the UFI code",
          "Preparing the PCN file and submitting it via the portal",
          "Tracking formulation changes",
          "Managing notification updates",
        ],
      },
    ],
    faqs: [
      { q: "Where is the UFI code obtained?", a: "It is generated using the company's tax identification information through the official UFI Generator tool." },
      { q: "What happens when the formulation changes?", a: "A new UFI is generated, the PCN notification is updated, and the label is reprinted." },
    ],
  },

  {
    slug: "kimyasal-envanter",
    icon: "Database",
    image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1600&q=80",
    title: "Chemical Inventory Check",
    tagline: "Regulation-Compliant Inventory Analysis",
    short: "Assessment of regulatory obligations and inventory analysis.",
    description:
      "CAS/EC-based inventory screening, tonnage analysis, and a multi-regime obligation report.",
    highlights: [
      "CAS / EC Matching",
      "Tonnage Analysis",
      "Obligation Map",
      "Risk Prioritization",
    ],
    sections: [
      {
        heading: "Why an Inventory Check?",
        paragraphs: [
          "A chemical inventory is not just a warehouse-management tool — it is also a regulatory-compliance tool. A properly maintained inventory makes it easier to analyze obligations across multiple regimes such as KKDİK, SEA, Biocidal, and REACH.",
        ],
      },
      {
        heading: "Our Scope of Work",
        bullets: [
          "Substance identification by CAS / EC number",
          "Annual tonnage tracking (production + import)",
          "Assessment of intended use (downstream use, intermediate, formulation)",
          "A map of obligations under the relevant regulations",
          "Risk-prioritization report",
        ],
      },
    ],
    faqs: [
      { q: "How long does an inventory study take?", a: "Typically 2–6 weeks, depending on the number of substances and data quality." },
      { q: "How often should it be renewed?", a: "A comprehensive screening is recommended at least once a year, with immediate updates whenever the formulation changes." },
    ],
  },

  {
    slug: "teknik-dosya",
    icon: "FolderCog",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1600&q=80",
    title: "Technical Dossier Preparation",
    tagline: "IUCLID and Chemical Safety Report",
    short: "Support for preparing the technical documentation required under chemicals legislation.",
    description:
      "Preparation of IUCLID files, the Chemical Safety Report (CSR), and exposure scenarios.",
    highlights: [
      "IUCLID Dossier",
      "Chemical Safety Report (CSR)",
      "Exposure Scenarios",
      "Technical Data Collection",
    ],
    sections: [
      {
        heading: "What Is a Technical Dossier?",
        paragraphs: [
          "This is the technical data set that must be submitted for substances registered under KKDİK and REACH. It includes substance identity, physicochemical properties, toxicological and ecotoxicological data, and exposure scenarios.",
        ],
      },
      {
        heading: "Our Scope of Service",
        bullets: [
          "Creating and organizing the IUCLID dossier",
          "Substance Identity report",
          "(Q)SAR / read-across strategy",
          "Preparing the Chemical Safety Report (CSR)",
          "Exposure-scenario modeling",
        ],
      },
    ],
    faqs: [
      { q: "Does the tonnage band affect dossier content?", a: "Yes. As tonnage increases, a broader data set and additional testing are required." },
      { q: "What if test data isn't available?", a: "Data gaps can be filled using read-across, QSAR, and weight-of-evidence approaches." },
    ],
  },
];

export const VALUES_TR = [
  "Teknik doğruluk",
  "Güvenilirlik",
  "Şeffaf iletişim",
  "Sürdürülebilir iş ilişkileri",
  "Sürekli gelişim",
  "Müşteri odaklı yaklaşım",
];

export const VALUES_EN = [
  "Technical accuracy",
  "Reliability",
  "Transparent communication",
  "Sustainable business relationships",
  "Continuous improvement",
  "Customer-focused approach",
];

export const WHY_US_TR = [
  { title: "Kimyasal Değerlendirme Uzmanı", desc: "Resmi yetkinlik ve sektör deneyimi." },
  { title: "KKDİK Odaklı Uzmanlık", desc: "Sadece kimyasal mevzuata odaklanan ekip." },
  { title: "Butik Hizmet", desc: "Her projeye birebir ilgi ve özelleştirilmiş yaklaşım." },
  { title: "Türkçe & İngilizce", desc: "Yerli ve global müşterilere çift dilli destek." },
  { title: "Uzaktan Çalışma", desc: "Lokasyon bağımsız, hızlı ve verimli iş akışı." },
  { title: "Hızlı İletişim", desc: "Sorularınıza aynı iş gününde geri dönüş." },
];

export const WHY_US_EN = [
  { title: "Chemical Assessment Expert", desc: "Official competence and industry experience." },
  { title: "KKDİK-Focused Expertise", desc: "A team focused solely on chemicals legislation." },
  { title: "Boutique Service", desc: "One-on-one attention and a tailored approach for every project." },
  { title: "Turkish & English", desc: "Bilingual support for local and global clients." },
  { title: "Remote Working", desc: "Location-independent, fast, and efficient workflow." },
  { title: "Fast Communication", desc: "Responses to your questions on the same business day." },
];

// Language-aware getters — prefer these over the raw _TR / _EN exports.
export const getServices = (lang) => (lang === "en" ? SERVICES_EN : SERVICES_TR);
export const getValues = (lang) => (lang === "en" ? VALUES_EN : VALUES_TR);
export const getWhyUs = (lang) => (lang === "en" ? WHY_US_EN : WHY_US_TR);

// Backward-compatible defaults (Turkish) for any code that still imports
// these directly.
export const SERVICES = SERVICES_TR;
export const VALUES = VALUES_TR;
export const WHY_US = WHY_US_TR;
